<template>
  <div class="con">
    <div class="empty">
      <div class="picture">
        <img :src="img" alt />
      </div>
      <div class="option">{{ context }}</div>
    </div>
  </div>
</template>

<script>
import bg from '@/assets/img/empty.png';
export default {
  props: ['img', 'width', 'context'],
  components: {},
  data() {
    return {
      bg,
    };
  },
};
</script>

<style lang="less" scoped>
.empty {
  // img {
  //   width: 100%;
  //   height: 100%;
  // }
  margin-top: 184px;

  .picture {
    display: flex;
    justify-content: center;
    align-items: center;
    // width: 100%;
    // height: 100%;
    // position: relative;
  }
  .option {
    text-align: center;
    margin-top: 20px;
    font-size: 28px;
    color: #5d6067;
    line-height: 28px;
  }
}
</style>
